let ready = false;
const startedKey = "lm_meta_adv_start";

export function initPixel(id) {
  if (ready || !id || typeof window === "undefined") return;
  ready = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
  s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
}

const fbq = (...args) => {
  if (ready && window.fbq) window.fbq(...args);
};

export const metaPageView = () => fbq("track", "PageView");

export const metaAdvisorStart = (entry) => {
  if (sessionStorage.getItem(startedKey)) return;
  sessionStorage.setItem(startedKey, "1");
  fbq("trackCustom", "AdvisorStart", { entry });
};

export const metaAdvisorResult = (business_type, count) =>
  fbq("trackCustom", "AdvisorResult", { business_type, solutions: count });

export const metaLead = (eventId, data) => fbq("track", "Lead", data, { eventID: eventId });

export const metaLeadFrom = (ev) => {
  if (!ev?.event_id) return;
  const { event_id, ...data } = ev;
  metaLead(event_id, data);
};

const cookie = (name) => document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1] || "";

export function metaBrowserIds() {
  let fbc = cookie("_fbc");
  if (!fbc) {
    const clid = new URLSearchParams(window.location.search).get("fbclid") || (() => {
      try { return JSON.parse(localStorage.getItem("lm_src") || "{}").fbclid || ""; } catch { return ""; }
    })();
    if (clid) fbc = `fb.1.${Date.now()}.${clid}`;
  }
  return { fbp: cookie("_fbp"), fbc, url: window.location.href };
}
